import { initValidate } from 'libs/validate'
import { setCookie, getCookie } from '@convertdigital/gamma-cookie'
import { getData, select, removeClass } from 'helpers/dom'

const selectors = {
  MODAL_DIALOG_SELECTOR: 'modal-dialog',
  NEWSLETTER_COOKIE: 'newsletterCookie',
  COOKIE_DAY_EXPIRED: 60 * 60 * 24 * 10,
  FORM_SELECTOR: 'form',
  MESSAGE_SUCCESS_SELECTOR: '.js-message-success',
  NOTICE_HIDE_CLASS: 'notice-hidden',
  NOTICE_MAIN_SELECTOR: 'notice-main'
}

class NewsletterPopup extends HTMLElement {
  constructor() {
    super()

    this.modal = select(selectors.MODAL_DIALOG_SELECTOR, this)
    this.form = select(selectors.FORM_SELECTOR, this)
    this.messageSuccessEl = select(selectors.MESSAGE_SUCCESS_SELECTOR, this)
    this.noticeMainEl = select(selectors.NOTICE_MAIN_SELECTOR, this)
    this.delayTime = getData('delay', this) * 1000

    const validate = initValidate(this.form, true)

    validate.onSuccess((event) => {
      event.preventDefault()
      this.onSubmitForm(this.form)
    })
  }

  connectedCallback() {
    if (!this.modal) return
    this.openModal()
  }

  openModal() {
    if (!getCookie(selectors.NEWSLETTER_COOKIE)) {
      setTimeout(() => {
        this.modal.show()

        setCookie(selectors.NEWSLETTER_COOKIE, 1, selectors.COOKIE_DAY_EXPIRED)
      }, this.delayTime)
    }
  }

  async onSubmitForm(form) {
    if (!form) return

    const { portalId, newsletterFormId } = window.GM_STATE.apps.hubSpot
    const data = new FormData(form)
    const fields = Array.from(data.entries()).map(([name, value]) => ({ name, value }))

    try {
      const req = await fetch(
        `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${newsletterFormId}`,
        {
          method: 'POST',
          body: JSON.stringify({
            fields
          }),
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )

      if (req.status === 200) {
        const res = await req.json()

        if (res.inlineMessage) {
          this.messageSuccessEl.innerText = res.inlineMessage
          removeClass(selectors.NOTICE_HIDE_CLASS, this.noticeMainEl)
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Form submission failed:', error)
    }
  }
}

if (!customElements.get('newsletter-popup')) {
  customElements.define('newsletter-popup', NewsletterPopup)
}
